/*
 @flow
 @format
*/

import * as React from 'react';

type Props = { title: string } & React.ElementConfig<any>;

export default ({ title, children }: Props) => (
  <div
    className="alert alert-danger"
    style={{ marginTop: '20px', width: '80vw', marginLeft: 'auto', marginRight: 'auto' }}
    role="alert"
  >
    <h4>{title}</h4>
    {children}
  </div>
);
